import React, {FC} from "react";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import _t from "../../../../lang/translate";
import TaxOfferBaseInfo from "./taxOfferBaseInfo";
import TaxOfferInfo from "./taxOfferInfo";
import DividerLine from "../../../../components/lineSplit";
import TaxRecalculateInfo from "./TaxRecalculateInfo";

const TaxOfferForm: FC = () => {
  const { taxCase } = TaxCaseStore.useContainer();
  const { expired } = taxCase.flags;

  const selectedProduct = expired ? 3 : 1;


  return (
    <>
      <TaxOfferBaseInfo />

      <DividerLine fluid />

      <h4 className="text-lighter mb-1">
        {_t('your', 'price')}
      </h4>

      {selectedProduct === 1 ? <TaxOfferInfo /> : null}
      {selectedProduct === 3 ? <TaxRecalculateInfo /> : null}
    </>
  );
};

export default TaxOfferForm;
